@if (account) {
  <div
    class="w-[90%] lg:w-[1069px] mt-[30px] m-auto border border-textbox-border bg-surface-background rounded-[10px] flex flex-col lg:flex-row justify-between items-center py-[24px] lg:py-[10px] px-[24px]">
    <p class="font-termina text-center lg:text-left text-[24px] lg:text-[32px]">{{ account.displayName }}</p>
    <div class="flex gap-4 mt-2 lg:mt-0 font-montserrat text-[20px] h-full">
      <div (click)="onClickSwitch()" class="flex items-center gap-4 text-support-text italic cursor-pointer">
        <p>Switch</p>
        <img alt="Switch account" class="m-auto w-[19px]" src="assets/icons/switch-gray.svg" />
      </div>
      <div class="h-[34px] w-[2px] rounded-full bg-textbox-border"></div>
      <div (click)="onClickNew()" class="flex items-center gap-4 text-support-text italic cursor-pointer">
        <p>New</p>
        <span class="m-auto w-[19px] material-icons text-support-text">add</span>
      </div>
    </div>
  </div>
}
